<template>
  <v-col cols="9" v-if="chatEnabled">
    <v-card class="align-start metrics-card-middle-bottom">
      <v-card-title class="d-flex justify-space-between">
        <div class="hidden-element">Hidden</div>
        <!--Hidden element to allow center and right align of label and icon-->
        <label class="font-weight-bold text-decoration-underline">Bot Performance</label>
        <tooltip>
          <p>Bot performance across the selected date range</p>
        </tooltip>
      </v-card-title>
      <v-card-text class="d-flex justify-space-around metrics-card-text">
        <StatsValue :loading="loading" title="Impressions">{{ impressions }}</StatsValue>
        <StatsValue
          :loading="loading"
          title="Icebreakers dismissed"
          :subtitle="icebreakersDismissedPercentage">
          {{ icebreakersDismissed }}
        </StatsValue>
        <StatsValue :loading="loading" title="Chats Opened" :subtitle="chatsOpenedPercentage">
          {{ chatsOpened }}
        </StatsValue>
        <StatsValue :loading="loading" title="Engagements" :subtitle="engagementsPercentage">
          {{ engagements }}
        </StatsValue>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {LoadingState} from '@/store/constants';
import StatsValue from '@/components/HealthScore/StatsValue.vue';
import {createPercentageSubtitle} from '@/components/HealthScore/healthScoreHelpers';
import Tooltip from '@/components/HealthScore/Tooltip.vue';

export default {
  name: 'BotPerformance',
  components: {Tooltip, StatsValue},
  computed: {
    ...mapState('healthScoreStore', ['chatOverview', 'chatEnabled']),
    ...mapGetters('healthScoreStore', ['impressions', 'engagements']),
    loading() {
      return this.chatOverview.state === LoadingState.LOADING;
    },
    icebreakersDismissed() {
      const icebreakerDismissed = this.chatOverview.data.find(
        element => element.EVENT_NAME === 'icebreaker_dismissed'
      );
      return icebreakerDismissed ? icebreakerDismissed.RESULT : 0;
    },
    icebreakersDismissedPercentage() {
      return createPercentageSubtitle(this.icebreakersDismissed, this.impressions, 'Impressions');
    },
    chatsOpened() {
      const conversationsStarted = this.chatOverview.data.find(
        element => element.EVENT_NAME === 'chat_opened'
      );
      return conversationsStarted ? conversationsStarted.RESULT : 0;
    },
    chatsOpenedPercentage() {
      return createPercentageSubtitle(this.chatsOpened, this.impressions, 'Impressions');
    },
    engagementsPercentage() {
      return createPercentageSubtitle(this.engagements, this.chatsOpened, 'Chats opened');
    },
  },
};
</script>
